import { createSlice } from "@reduxjs/toolkit";


const nameSlice = createSlice({
    name:'Global',
    initialState:{
        state:0
    },
    reducers:{
        changeState(state,{payload}){
            state.state = payload
        }
    }
})
export const getters = (state) => state.Global;
export const {changeState} = nameSlice.actions
export default nameSlice.reducer
